import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin';

import api from "./api";

export default (type, params) => {
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        return api.login(username, password).then(r => {
            if (r && r.returnCode === 0) {
                return api.whoami().then(response => {
                    if (response.returnCode === 0) {
                        const userData = response.body;
                        if (userData.type === "CA" && !!userData.cityAdmin) {
                            const city = userData.city;
                            if (!city) {
                                throw new Error(`No city data found for user  : ${userData.fullName}`);
                            }
                            sessionStorage.setItem("cityId", city.id);
                            sessionStorage.setItem("cityUrl", `cities/${city.id}`);
                            sessionStorage.setItem("cityName", city.name);
                            sessionStorage.setItem("username", username);

                            sessionStorage.setItem("zutp", btoa(userData.type));
                        } else if (userData.type === "SA") {
                            sessionStorage.setItem("username", username);
                            sessionStorage.setItem("zutp", btoa(userData.type));
                        } else if (userData.type === "MA") {
                            const merchant = userData.merchant;
                            if (!merchant) {
                                throw new Error(`No Merchant data found for user  : ${userData.fullName}`);
                            }
                            sessionStorage.setItem("merchantId", merchant.id);
                            sessionStorage.setItem("merchantUrl", `merchants/${merchant.id}`);
                            sessionStorage.setItem("merchantName", merchant.name);
                            sessionStorage.setItem("username", username);
                            sessionStorage.setItem("zutp", btoa(userData.type));
                        } else {
                            throw new Error(`You are not allowed to use this Application!`);
                        }
                    } else {
                        throw new Error(`Unrecongnized user : ${response.message}`);
                    }
                });
            } else {
                throw new Error("Something went wrong!");
            }
        }).catch(e => {
            throw new Error(`Authentication Failed : ${e.message}`);
        });
    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        api.logout();
        sessionStorage.clear();
        return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const status = params.status;

        if (status === 401 || status === 403) {
            sessionStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        return sessionStorage.getItem('username') ? Promise.resolve() : Promise.reject();
    }
    return Promise.reject('Unknown method');
};